import 'select2';

/**
 * @type {JQuery<HTMLElement>}
 */
var $statuses = $('#statuses > .badge');
var $selector;

/**
 * Initialize.
 *
 * @param  {jQuery} $el
 */
export function init ($el) {
  $selector = $el;

  _bindEvents();
  _render();
}

function _formatStatus(status) {
  if(status.id) {
    return $statuses.eq(status.id - 1).clone();
  }
}

/**
 * Bind events.
 */
function _bindEvents () {
  $selector.on('change', _updateStatus);
}

/**
 * Update the status of an order.
 *
 * @param  {Event} event
 */
function _updateStatus (event) {
  let $target = $(event.target);

  $.ajax({
    type: $target.data('method') || 'PUT',
    url: $target.data('url'),
    data: {
      [$target.attr('name')]: $target.val(),
    },
  });
}

/**
 * Render the status dropdowns.
 */
function _render () {
  $selector.select2({
    width: '100%',
    templateResult: _formatStatus,
    templateSelection: _formatStatus
  });

  /**
   * Hide the search box.
   *
   * @link https://select2.org/searching#multi-select
   */
  $selector.on('select2:opening select2:closing', () => {
    $selector.parent()
      .find('.select2-search__field')
      .prop('disabled', true);
  });
}
